import './ModalContainer.css';
import { useRef } from 'react';
import { createPortal } from 'react-dom';

import CloseIcon from '@mui/icons-material/Close';

export const ModalContainer = (props) => {

  const modalContainerRef = useRef(null);

  let modalClassName = "modal";
  if (props.smallPromptFormat) {
    modalClassName += " smallPromptFormat";
  }
  if (props.noMainContentPadding) {
    modalClassName += " noMainContentPadding";
  }

  const modalContainerClickHandler = (event) => {
    if (props.hideHeaderDismissButton) {
      return; // if header dismiss button is hidden, then don't allow dismissal by clicking outside the modal
    }
    if (event.target !== modalContainerRef.current) {
      return;
    }
    props.onDismiss();
  };

  return createPortal(
    <div className="modalContainer" onClick={modalContainerClickHandler} ref={modalContainerRef}>
      <div className={modalClassName}>
        <div className="modalHeader">
          <div className="buttonSpacer"></div>
          <h3>
            {props.title || null}
          </h3>
          {props.hideHeaderDismissButton ? 
            <div className="buttonSpacer"></div>
          :
            <button onClick={props.onDismiss}><CloseIcon /></button>
          }
        </div>
        <div className="modalMainContent">
          {props.children}
        </div>
      </div>
    </div>,
    document.querySelector("#modal-root")
  );
}